module.exports = __webpack_public_path__ + "catalog/items/deskdouble/deskdouble.png";